import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
export default {
  name: 'LoadingCanvas',
  data() {
    return {
      animationStart: null,
      // 動畫計時
      flashRate: 300,
      // 動畫速度,數字愈小愈快
      move: 0,
      // 動畫格數
      maxMove: 12,
      // 動畫總格數
      canvas: null,
      // canvas
      canvasWidth: 60,
      // canvas width
      canvasHeight: 60,
      // canvas height
      boundLeft: -2,
      // 左邊距離
      boundRight: 60,
      // 右邊距離
      boundTop: 0,
      // 上邊距離
      boundBottom: 60,
      // 下邊距離
      defaultColor: '#e02323',
      // 中間填充動畫顏色

      drawStepsQueue: [1],
      isAnimationStart: true // 预设播放
    };
  },

  computed: {
    ...mapState('common', ['loading', 'loadingCount']),
    show() {
      // return (this.loading.show)
      return this.loadingCount > 0;
    },
    color() {
      return this.defaultColor;
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.isAnimationStart = true;
        // 没有队列中的动画的话
        if (this.drawStepsQueue.length === 0) {
          this.drawStepsQueue = [1]; // same as default
        }

        window.requestAnimationFrame(this.renderAnimationFrame);
      }
    }
  },
  mounted() {
    window.requestAnimationFrame(this.renderAnimationFrame);
  },
  methods: {
    renderAnimationFrame() {
      if (this.animationStart === null) {
        this.animationStart = Date.now();
      }
      let now = Date.now();
      let elapsed = now - this.animationStart;

      // 一影格动画播完
      if (elapsed >= this.flashRate) {
        if (this.drawStepsQueue.length > 0) {
          // 播下一个影格动画
          this.animationStart = now;
          this.step();
        } else {
          // 所有动画皆播完毕
          this.animationStart = 0;
          this.isAnimationStart = false;
        }
      } else {
        window.requestAnimationFrame(this.renderAnimationFrame);
      }
    },
    step() {
      const lastOne = this.drawStepsQueue[this.drawStepsQueue.length - 1];

      // 可播放的话, 在队列后面继续堆叠影格动画
      if (this.show) {
        if (lastOne < this.maxMove) {
          this.drawStepsQueue.push(lastOne + 1);
        } else {
          this.drawStepsQueue.push(1);
        }
      }

      // 队列的动画都播放完之前
      if (this.drawStepsQueue.length > 0) {
        // 播放伫列第一个的动画
        this['drawStep' + this.drawStepsQueue[0]]();
        this.drawStepsQueue.shift();
        // 继续下一个
        window.requestAnimationFrame(this.renderAnimationFrame);
      }
    },
    getContext() {
      let canvas = document.getElementById('canvas');
      canvas.width = this.canvasWidth;
      canvas.height = this.canvasHeight;
      return canvas.getContext('2d');
    },
    drawStep1() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
    },
    drawStep2() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(20, 105, 50, 0, Math.PI * 2);
      ctx.fill();
    },
    drawStep3() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(20, 75, 30, 0, Math.PI * 2);
      ctx.fill();
    },
    drawStep4() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(8, 50);
      ctx.bezierCurveTo(10, 45, 30, 45, 38, 42);
      ctx.bezierCurveTo(45, 40, 50, 40, this.boundRight, 37);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(8, this.boundBottom);
      ctx.lineTo(8, 50);
      ctx.fill();
    },
    drawStep5() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.boundLeft, 30);
      ctx.bezierCurveTo(5, 35, 20, 40, 38, 42);
      ctx.bezierCurveTo(45, 40, 50, 45, this.boundRight, 50);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(this.boundLeft, this.boundBottom);
      ctx.lineTo(this.boundLeft, 30);
      ctx.fill();
    },
    drawStep6() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.boundLeft, 45);
      ctx.bezierCurveTo(15, 35, 20, 40, 40, 35);
      ctx.bezierCurveTo(50, 35, 50, 30, this.boundRight, 30);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(this.boundLeft, this.boundBottom);
      ctx.lineTo(this.boundLeft, 45);
      ctx.fill();
    },
    drawStep7() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.boundLeft, 25);
      ctx.bezierCurveTo(10, 25, 10, 30, 20, 30);
      ctx.bezierCurveTo(50, 35, 50, 30, this.boundRight, 50);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(this.boundLeft, this.boundBottom);
      ctx.lineTo(this.boundLeft, 25);
      ctx.fill();
    },
    drawStep8() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.boundLeft, 37);
      ctx.bezierCurveTo(10, 35, 10, 30, 30, 30);
      ctx.bezierCurveTo(35, 30, 50, 25, this.boundRight, 20);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(this.boundLeft, this.boundBottom);
      ctx.lineTo(this.boundLeft, 37);
      ctx.fill();
    },
    drawStep9() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.boundLeft, 15);
      ctx.bezierCurveTo(10, 20, 20, 20, 25, 20);
      ctx.bezierCurveTo(50, 25, 50, 25, this.boundRight, 30);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(this.boundLeft, this.boundBottom);
      ctx.lineTo(this.boundLeft, 0);
      ctx.fill();
    },
    drawStep10() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.boundLeft, 25);
      ctx.bezierCurveTo(5, 20, 10, 20, 30, 18);
      ctx.bezierCurveTo(45, 15, 45, 15, this.boundRight, 10);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(this.boundLeft, this.boundBottom);
      ctx.lineTo(this.boundLeft, 25);
      ctx.fill();
    },
    drawStep11() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.boundLeft, 2);
      ctx.bezierCurveTo(5, 5, 5, 10, 40, 12);
      ctx.bezierCurveTo(50, 15, 50, 15, this.boundRight, 17);
      ctx.lineTo(this.boundRight, this.boundBottom);
      ctx.lineTo(this.boundLeft, this.boundBottom);
      ctx.lineTo(this.boundLeft, 0);
      ctx.fill();
    },
    drawStep12() {
      let ctx = this.getContext();
      ctx.clearRect(this.boundLeft, this.boundTop, this.canvasWidth, this.canvasHeight);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(30, 30, 32, 32, Math.PI * 2, true);
      ctx.fill();
    }
  }
};